
import { defineComponent, PropType } from 'vue'
import { IIFormItems } from '../types'

export default defineComponent({
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    formItems: {
      type: Array as PropType<IIFormItems[]>,
      // vue3 default中如果是物件和陣列要使用箭頭函數
      default: () => []
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    itemStyle: {
      type: Object,
      default: () => ({ padding: '10px 40px' })
    },
    colLayout: {
      type: Object,
      default: () => {
        return {
          xl: 6, // 24/6 = 4 1920為一排4個
          lg: 8,
          md: 12,
          sm: 24,
          xs: 24
        }
      }
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // 如果直接使用物件 會修改到物件本身的引用指針
    // const formData = ref({ ...props.modelValue })

    // watch(
    //   formData,
    //   (newValue) => {
    //     emit('update:modelValue', newValue)
    //   },
    //   {
    //     deep: true
    //   }
    // )

    const handleValueChange = (value: any, field: string) => {
      emit('update:modelValue', {
        ...props.modelValue,
        [field]: value
      })
    }

    return {
      // formData,
      handleValueChange
    }
  }
})
